export { default as NDivider, dividerProps } from './src/Divider';
